import { FOCUSABLE_ELEMENTS_SELECTOR } from './getFocusableElements';

const getFirstFocusableElement = (container) => {
  return container.querySelector(FOCUSABLE_ELEMENTS_SELECTOR);
};

export default getFirstFocusableElement;
